import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const ExportExcel = ({data}) => {
  const fetchAndExport = async () => {
    console.log(data,"dara")
    try {
      const formattedData = data.map(entry => ({
        "First Name": entry.first_name,
        "Last Name": entry.last_name,
        Email: entry.email,
        Phone: entry.phone,
        Services: (() => {
          try {
            const parsed = JSON.parse(entry.services);
            if (Array.isArray(parsed)) {
              return parsed
                .map(service =>
                  service
                    .split("_")
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(" ")
                )
                .join(", ");
            }
          } catch {
            return typeof entry.services === "string"
              ? entry.services
                .split("_")
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ")
              : "";
          }
        })(),
        Message: entry.message,
      }));

      const headers = ["First Name", "Last Name", "Email", "Phone", "Services", "Message"];
      const worksheet = XLSX.utils.json_to_sheet([], { skipHeader: true });

      // Add headers
      XLSX.utils.sheet_add_aoa(worksheet, [headers]);

      // ✅ Apply green background to each header cell
      headers.forEach((_, colIndex) => {
        const cellAddress = XLSX.utils.encode_cell({ r: 0, c: colIndex });
        if (!worksheet[cellAddress]) return;

        worksheet[cellAddress].s = {
          fill: {
            patternType: "solid",
            fgColor: { rgb: "C6EFCE" }, // Light green
          },
          font: {
            bold: true,
            color: { rgb: "006100" }, // Dark green
          },
          alignment: {
            horizontal: "center",
            vertical: "center",
          },
        };
      });

      // Add data starting at row 2
      XLSX.utils.sheet_add_json(worksheet, formattedData, {
        skipHeader: true,
        origin: "A2",
      });

      worksheet["!cols"] = headers.map(() => ({ wch: 20 }));

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Contact Info");

      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array", cellStyles: true });
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, "Contact Info.xlsx");
    } catch (error) {
      console.error("Error fetching or exporting data:", error);
    }
  };

  return (
    <div className="pt-6 flex justify-end">
      <button onClick={fetchAndExport} className="py-1 px-2 bg-[#0D283F] text-white rounded">
        Download Excel
      </button>
    </div>
  );
};

export default ExportExcel;
